import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {EmployeeFolder} from "./EmployeeFolder";

export const employeeFolderFields: IntercateKeysMap<EmployeeFolder, EntityField<EmployeeFolder>> = {
	id: {
		name: "id", dataType: EntityFieldDataType._number, label: "Id"
	},
	firstName: {
		name: "firstName", dataType: EntityFieldDataType._string, label: "First name",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	lastName: {
		name: "lastName", dataType: EntityFieldDataType._string, label: "Last name",
		keyfilter: "pnum",
		sortable: true,
		validator: { required: true, isNumber: true, isPositiveOrZero: true }
	},
	title: {
		name: "title", dataType: EntityFieldDataType._derived, label: "title",
		value: (item: EmployeeFolder) => {
			return `${item.lastName} ${item.lastName}`
		}
	}
};

const employeeFolderFieldsArray: Array<EntityField<EmployeeFolder>> = [
	employeeFolderFields.firstName,
	employeeFolderFields.lastName
];

export const employeeFolderFieldsDescriptor: EntityFieldsDescriptor<EmployeeFolder> = {
	listFields: employeeFolderFieldsArray,
	createFormFields: employeeFolderFieldsArray,
	updateFormFields: employeeFolderFieldsArray
}
